// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class EscalationWindowStats {
  readonly count: number;

  constructor(data: { [key: string]: any } = {}) {
    this.count = data.count === undefined ? 0 : data.count;
  }

  static zero(): EscalationWindowStats {
    const zeroValues: ExcludeMethodsDeep<EscalationWindowStats> = {
      count: 0,
    };
    return new EscalationWindowStats(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type EscalationWindowStatsWireFormat = {
  count: number;
};

type NewEscalationWindowStatsProps = PartialDeep<
  EscalationWindowStats,
  { recurseIntoArrays: true }
>;
export const NewEscalationWindowStats: (
  props: NewEscalationWindowStatsProps,
) => EscalationWindowStats = (props) => new EscalationWindowStats(props);

type NewEscalationWindowStatsFromWireFormatProps = PartialDeep<
  EscalationWindowStatsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewEscalationWindowStatsFromWireFormat: (
  props: NewEscalationWindowStatsFromWireFormatProps,
) => EscalationWindowStats = (props) => new EscalationWindowStats(props);
